<template>
  <div style="width: 100%;height: 100%;">
    <div v-if="startNps" style="width: 100%;height: 100%;">
      <sky-feedback-dialog :feedback="feedback" :isModel="isModel" :sourceFrom="sourceFrom" @cb="cbTop" />
    </div>
    <div v-if="loading">加载中...</div>
    <div>{{ message }}</div>
  </div>
</template>
<script>
import FeedbackDialog from '@/components/FeedbackDialog'
import GlobalConst from '@/constant/globalConst'

export default {
  name: 'npsCollection',
  comments: {
    FeedbackDialog
  },
  data() {
    return {
      startNps: false,
      loading: true,
      feedback: {
        id: null,
        toolId: null,
        toolName: null,
        saveTimeRate: null,
        recommendRating: null,
        feedback: null,
        npsSign: null
      },
      isModel: true,
      sourceFrom: 'nps',
      message: ''
    }
  },
  created() {
    //eg: /#/npsCollection?npsToolId=4a25288b-6e8b-4ad4-86ea-67a79fc1c1c3&npsSign=x9sgQYLWLYiHpIqcVN8iNFP6lGy5hFH9k5TrvOCbJsE%3D&isModel=N
    document.documentElement.style.fontSize = '24px'
    var query = this.$route.query
    this.feedback.toolId = query.npsToolId
    this.feedback.npsSign = query.npsSign
    if (query.isModel && query.isModel === 'N') {
      this.isModel = false
    }
  },
  mounted() {
    this.$store.dispatch('CloseAllNotification')
    if (!this.feedback.toolId || !this.feedback.npsSign) {
      this.loading = false
      this.message = '请求参数有误，请确认'
      return
    }
    this.loading = false
    this.startNps = true
  },
  beforeDestroy() {},
  methods: {
    cbTop() {
      // 向主页面发送消息
      window.parent.postMessage('closeNpsWindow', GlobalConst.TRAIN_PLATFORM_URL)
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
#app iframe {
  border: 0 !important;
  object-fit: contain;
}
#app {
  margin: auto;
  justify-content: center;
  display: flex;
  align-items: center;
}
</style>
